const IFRAME_SELECTOR = ".js-iframe";
const IFRAME_CONTENT_SELECTOR = ".js-iframe__content";
const IFRAME_IMG_SELECTOR = ".js-iframe__img";
const IFRAME_PLAY_SELECTOR = ".js-iframe__play";

export const initIframeBlock = () => {
    const iframeBlocks = document.querySelectorAll(IFRAME_SELECTOR);
    iframeBlocks.forEach((wrap) => initIframeElement(wrap));
};

const initIframeElement = (wrap) => {
    const playBtns = wrap.querySelectorAll(IFRAME_PLAY_SELECTOR);
    const content = wrap.querySelector(IFRAME_CONTENT_SELECTOR);
    const imgEl = wrap.querySelector(IFRAME_IMG_SELECTOR);

    if(!content) return;

    playBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            const url = btn.dataset.url;
            if (!url) return;
            const iframe = createIframe(url);
            imgEl?.remove();
            content.appendChild(iframe);
        });
    });

    function createIframe(url) {
        const iframe = document.createElement("iframe");
        iframe.src = url;
        return iframe;
    }
};

initIframeBlock();
